import { HttpHeaders } from "@angular/common/http";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../common/app-config/app-configuration.service";
var AuthProviderProxy = /** @class */ (function () {
    function AuthProviderProxy(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    AuthProviderProxy.prototype.logout = function (reason, accessToken) {
        var headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.set("Authorization", "Bearer " + accessToken);
        return this.httpClient.request('POST', this.configService.Config.WebApiUrl + '/PatientPortalLogout/Logout', { body: reason, headers: headers });
    };
    AuthProviderProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthProviderProxy_Factory() { return new AuthProviderProxy(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigurationService)); }, token: AuthProviderProxy, providedIn: "root" });
    return AuthProviderProxy;
}());
export { AuthProviderProxy };
